/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import NeeDocumentsDataDocuments from './NeeDocumentsDataDocuments';

/**
 * The NeeDocumentsData model module.
 * @module model/NeeDocumentsData
 * @version 1.0.0
 */
class NeeDocumentsData {
    /**
     * Constructs a new <code>NeeDocumentsData</code>.
     * @alias module:model/NeeDocumentsData
     */
    constructor() { 
        
        NeeDocumentsData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NeeDocumentsData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NeeDocumentsData} obj Optional instance to populate.
     * @return {module:model/NeeDocumentsData} The populated <code>NeeDocumentsData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NeeDocumentsData();

            if (data.hasOwnProperty('nee_level_id')) {
                obj['nee_level_id'] = ApiClient.convertToType(data['nee_level_id'], 'Number');
            }
            if (data.hasOwnProperty('nee_level')) {
                obj['nee_level'] = ApiClient.convertToType(data['nee_level'], 'String');
            }
            if (data.hasOwnProperty('academic_section_id')) {
                obj['academic_section_id'] = ApiClient.convertToType(data['academic_section_id'], 'Number');
            }
            if (data.hasOwnProperty('academic_section')) {
                obj['academic_section'] = ApiClient.convertToType(data['academic_section'], 'String');
            }
            if (data.hasOwnProperty('outcome')) {
                obj['outcome'] = ApiClient.convertToType(data['outcome'], 'String');
            }
            if (data.hasOwnProperty('comments')) {
                obj['comments'] = ApiClient.convertToType(data['comments'], 'String');
            }
            if (data.hasOwnProperty('more_info')) {
                obj['more_info'] = ApiClient.convertToType(data['more_info'], 'String');
            }
            if (data.hasOwnProperty('status_id')) {
                obj['status_id'] = ApiClient.convertToType(data['status_id'], 'Number');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('documents')) {
                obj['documents'] = ApiClient.convertToType(data['documents'], [NeeDocumentsDataDocuments]);
            }
        }
        return obj;
    }


}

/**
 * @member {Number} nee_level_id
 */
NeeDocumentsData.prototype['nee_level_id'] = undefined;

/**
 * @member {String} nee_level
 */
NeeDocumentsData.prototype['nee_level'] = undefined;

/**
 * @member {Number} academic_section_id
 */
NeeDocumentsData.prototype['academic_section_id'] = undefined;

/**
 * @member {String} academic_section
 */
NeeDocumentsData.prototype['academic_section'] = undefined;

/**
 * @member {String} outcome
 */
NeeDocumentsData.prototype['outcome'] = undefined;

/**
 * @member {String} comments
 */
NeeDocumentsData.prototype['comments'] = undefined;

/**
 * @member {String} more_info
 */
NeeDocumentsData.prototype['more_info'] = undefined;

/**
 * @member {Number} status_id
 */
NeeDocumentsData.prototype['status_id'] = undefined;

/**
 * @member {String} status
 */
NeeDocumentsData.prototype['status'] = undefined;

/**
 * @member {Array.<module:model/NeeDocumentsDataDocuments>} documents
 */
NeeDocumentsData.prototype['documents'] = undefined;






export default NeeDocumentsData;

